// ------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template.
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
// ------------------------------------------------------------------------------

import { Dictionary } from '../../../shared/models/dictionary.model';
import { IBaseType } from '../../../shared/enums/ibase-type.enum';

export interface ICustomerCertificationType {
    id: number;
    value: string;
    displayValue: string;
    description: string;
    sortOrder: number;
    active: boolean;
}

export class CustomerCertificationType implements ICustomerCertificationType, IBaseType {
    public id: number;
    public value: string;
    public displayValue: string;
    public description: string;
    public sortOrder: number;
    public active: boolean;

    /**
		Returns Medical Exam Certificate CustomerCertificationType
	**/
    get MedicalExamCertificate(): ICustomerCertificationType {
        return this.FromId(1);
    }
    /**
		Returns Tribal Enrollment Card CustomerCertificationType
	**/
    get TribalEnrollmentCard(): ICustomerCertificationType {
        return this.FromId(2);
    }
    /**
		Returns Tribal Certificate of Indian Blood CustomerCertificationType
	**/
    get TribalCertificateofIndianBlood(): ICustomerCertificationType {
        return this.FromId(3);
    }
    /**
		Returns Legal Guardian Certificate CustomerCertificationType
	**/
    get LegalGuardianCertificate(): ICustomerCertificationType {
        return this.FromId(4);
    }
    /**
		Returns Driving Practice Certificate CustomerCertificationType
	**/
    get DrivingPracticeCertificate(): ICustomerCertificationType {
        return this.FromId(5);
    }
    /**
		Returns US Certificate of Naturalization CustomerCertificationType
	**/
    get USCertificateofNaturalization(): ICustomerCertificationType {
        return this.FromId(6);
    }
    /**
		Returns US Certificate of Citizenship CustomerCertificationType
	**/
    get USCertificateofCitizenship(): ICustomerCertificationType {
        return this.FromId(7);
    }
    /**
		Returns Marriage Certificate CustomerCertificationType
	**/
    get MarriageCertificate(): ICustomerCertificationType {
        return this.FromId(8);
    }
    /**
		Returns Birth Certificate CustomerCertificationType
	**/
    get BirthCertificate(): ICustomerCertificationType {
        return this.FromId(9);
    }
    /**
		Returns Motorcycle Instructor CustomerCertificationType
	**/
    get MotorcycleInstructor(): ICustomerCertificationType {
        return this.FromId(11);
    }
    /**
		Returns Special Performance Instructor CustomerCertificationType
	**/
    get SpecialPerformanceInstructor(): ICustomerCertificationType {
        return this.FromId(12);
    }
    /**
		Returns MVD Examiner CustomerCertificationType
	**/
    get MVDExaminer(): ICustomerCertificationType {
        return this.FromId(13);
    }
    /**
		Returns Traffic Survival School Instructor CustomerCertificationType
	**/
    get TrafficSurvivalSchoolInstructor(): ICustomerCertificationType {
        return this.FromId(14);
    }
    /**
		Returns Operator Instructor CustomerCertificationType
	**/
    get OperatorInstructor(): ICustomerCertificationType {
        return this.FromId(15);
    }
    /**
		Returns High School Instructor CustomerCertificationType
	**/
    get HighSchoolInstructor(): ICustomerCertificationType {
        return this.FromId(16);
    }
    /**
		Returns CDL Instructor CustomerCertificationType
	**/
    get CDLInstructor(): ICustomerCertificationType {
        return this.FromId(17);
    }
    /**
		Returns CDL Examiner CustomerCertificationType
	**/
    get CDLExaminer(): ICustomerCertificationType {
        return this.FromId(18);
    }
    /**
		Returns Third Party Traditional Processor CustomerCertificationType
	**/
    get ThirdPartyTraditionalProcessor(): ICustomerCertificationType {
        return this.FromId(19);
    }
    /**
		Returns Third Party Driver Services CustomerCertificationType
	**/
    get ThirdPartyDriverServices(): ICustomerCertificationType {
        return this.FromId(20);
    }
    /**
		Returns Bus Driver CustomerCertificationType
	**/
    get BusDriver(): ICustomerCertificationType {
        return this.FromId(21);
    }

    private _dictionary: Dictionary = new Dictionary([]);

    constructor() {
        this._dictionary.add('1', { id: 1, value: 'MedicalExamCertificate', displayValue: 'Medical Exam Certificate', description: 'Medical Exam Certificate', sortOrder: 999999, active: false });
        this._dictionary.add('2', { id: 2, value: 'TribalEnrollmentCard', displayValue: 'Tribal Enrollment Card', description: 'Tribal Enrollment Card', sortOrder: 999999, active: true });
        this._dictionary.add('3', { id: 3, value: 'TribalCertificateofIndianBlood', displayValue: 'Tribal Certificate of Indian Blood', description: 'Tribal Certificate of Indian Blood', sortOrder: 999999, active: true });
        this._dictionary.add('4', { id: 4, value: 'LegalGuardianCertificate', displayValue: 'Legal Guardian Certificate', description: 'Legal Guardian Certificate', sortOrder: 999999, active: true });
        this._dictionary.add('5', { id: 5, value: 'DrivingPracticeCertificate', displayValue: 'Driving Practice Certificate', description: 'Driving Practice Certificate', sortOrder: 999999, active: true });
        this._dictionary.add('6', { id: 6, value: 'USCertificateofNaturalization', displayValue: 'US Certificate of Naturalization', description: 'US Certificate of Naturalization', sortOrder: 999999, active: false });
        this._dictionary.add('7', { id: 7, value: 'USCertificateofCitizenship', displayValue: 'US Certificate of Citizenship', description: 'US Certificate of Citizenship', sortOrder: 999999, active: false });
        this._dictionary.add('8', { id: 8, value: 'MarriageCertificate', displayValue: 'Marriage Certificate', description: 'Marriage Certificate', sortOrder: 999999, active: true });
        this._dictionary.add('9', { id: 9, value: 'BirthCertificate', displayValue: 'Birth Certificate', description: 'Birth Certificate', sortOrder: 999999, active: false });
        this._dictionary.add('11', { id: 11, value: 'MotorcycleInstructor', displayValue: 'Motorcycle Instructor', description: 'Professional driving instructors authorized by the state to deliver courses that will satisfy Motorcycle knowledge and skill tests.', sortOrder: 999999, active: true });
        this._dictionary.add('12', { id: 12, value: 'SpecialPerformanceInstructor', displayValue: 'Special Performance Instructor', description: 'Professional driving instructors authorized by the state to deliver courses for adaptive driving and satisfy Non Commercial knowledge and skill tests. Test results from these types of instructors usually entail some sort of Restriction.', sortOrder: 999999, active: true });
        this._dictionary.add('13', { id: 13, value: 'MVDExaminer', displayValue: 'MVD Examiner', description: 'An internal ADOT Driving Instructor.', sortOrder: 999999, active: true });
        this._dictionary.add('14', { id: 14, value: 'TrafficSurvivalSchoolInstructor', displayValue: 'Traffic Survival School Instructor', description: 'Professional driving instructors authorized by the state to deliver courses that will satisfy Traffic Survival School Compliance.', sortOrder: 999999, active: true });
        this._dictionary.add('15', { id: 15, value: 'OperatorInstructor', displayValue: 'Operator Instructor', description: 'Professional driving instructors authorized by the state to deliver courses that will satisfy Non Commercial knowledge and skill tests.', sortOrder: 999999, active: true });
        this._dictionary.add('16', { id: 16, value: 'HighSchoolInstructor', displayValue: 'High School Instructor', description: 'Professional driving instructors authorized by the state to deliver courses that will satisfy Non Commercial knowledge and skill tests.', sortOrder: 999999, active: true });
        this._dictionary.add('17', { id: 17, value: 'CDLInstructor', displayValue: 'CDL Instructor', description: 'Commerical Driver License instructor authorized by the state to deliver Commercial courses.', sortOrder: 999999, active: true });
        this._dictionary.add('18', { id: 18, value: 'CDLExaminer', displayValue: 'CDL Examiner', description: 'Commerical Driver License examiner authorized by the state to deliver Commercial courses.', sortOrder: 999999, active: true });
        this._dictionary.add('19', { id: 19, value: 'ThirdPartyTraditionalProcessor', displayValue: 'Third Party Traditional Processor', description: 'Third Party Traditional Processor', sortOrder: 999999, active: true });
        this._dictionary.add('20', { id: 20, value: 'ThirdPartyDriverServices', displayValue: 'Third Party Driver Services', description: 'Third Party Driver Services', sortOrder: 999999, active: true });
        this._dictionary.add('21', { id: 21, value: 'BusDriver', displayValue: 'Bus Driver', description: 'Bus Driver', sortOrder: 999999, active: true });
    }

    public ToString(): string {
        return this.displayValue == null ? null : this.displayValue.toString();
    }

    public FromId(id: number): ICustomerCertificationType {
        return this._dictionary[id];
    }

    public FromValue(value: string): ICustomerCertificationType {
        var match = this._dictionary.getValues().filter(d => d.value == value);

        if (match.length > 0) {
            return this._dictionary[match[0].id];
        } else {
            return undefined;
        }
    }

    public GetAll(): ICustomerCertificationType[] {
        return this._dictionary.getValues().sort(this.sort_by('sortOrder', false, null, this.sort_by('displayValue', false, null, null)));
    }

    public GetActive(): ICustomerCertificationType[] {
        return this.GetAll().filter(d => d.active);
    }

    public Sort(primaryField, secondaryField, reverse): ICustomerCertificationType[] {
        return this.GetAll().sort(this.sort_by(primaryField, reverse, null, secondaryField != null ? this.sort_by(secondaryField, reverse, null, null) : null));
    }

    private sort_by = (path, reverse, primer, then) => {
        var get = (obj, path) => {
                if (path) {
                    path = path.split('.');

                    for (var i = 0, len = path.length - 1; i < len; i++) {
                        obj = obj[path[i]];
                    }

                    return obj[path[len]];
                }
                return obj;
            },
            prime = (obj) => primer ? primer(get(obj, path)) : get(obj, path);

        return (a, b) => {
            var A = prime(a),
                B = prime(b);

            return (
                (A < B) ? -1 :
                    (A > B) ? 1 :
                        (typeof then === 'function') ? then(a, b) : 0
            ) * [1, -1][+!!reverse];
        };
    };
}
